<template>
  <section>
    <el-form inline>
      <el-form-item label="关键字">
        <el-input
          v-model="filters.keyword"
          placeholder="关键字"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.enabled" multiple="">
          <el-option label="正常" value="1"></el-option>
          <el-option label="禁用" value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!-- <el-button v-if="$hasRight(buttonList,'Users:Users:DataPermission')" >测试权限</el-button> -->

    <!--列表-->
    <el-table-bar :fixed="true" :bottom="35">
      <el-table
        border
        :data="users"
        highlight-current-row
        @current-change="selectCurrentRow"
        v-loading="listLoading"
        @selection-change="selsChange"
        style="width: 100%"
      >
        <!-- <el-table-column type="selection" width="50">
                </el-table-column> -->
        <el-table-column type="index" width="80"> </el-table-column>
        <el-table-column
          prop="organizationFullName"
          label="所属"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column prop="realName" label="姓名" width="" sortable>
        </el-table-column>
        <el-table-column prop="loginName" label="登录名" width="" sortable>
        </el-table-column>
        <el-table-column prop="roleNames" label="角色" width="" sortable>
          <template slot-scope="scope">
            <el-tag v-for="item in scope.row.roleNames" :key="item.id">{{
              item
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱" width="" sortable>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="" sortable>
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status == 1 ? 'success' : 'danger'"
              disable-transitions
              >{{ scope.row.status == 1 ? "正常" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="150">
                    <template scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" @click="handleDel(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column> -->
      </el-table>
    </el-table-bar>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="登录名" prop="loginName">
          <el-col :span="16">
            <el-input
              v-model="editForm.loginName"
              auto-complete="off"
              disabled
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-col :span="16">
            <el-input
              v-model="editForm.realName"
              auto-complete="off"
            ></el-input>
          </el-col>
        </el-form-item>
        <!--<el-form-item label="密码" prop="uLoginPWD">-->
        <!--<el-input v-model="editForm.uLoginPWD" show-password  auto-complete="off"></el-input>-->
        <!--</el-form-item>-->

        <el-form-item label="角色" prop="roleIds">
          <el-select
            multiple
            v-model="editForm.roleIds"
            placeholder="请选择角色"
          >
            <!-- <el-option  :key="0" :label="'未选择角色'" :value="0"></el-option> -->
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-col :span="16">
            <el-input v-model="editForm.email" auto-complete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <el-select v-model="editForm.status" placeholder="请选择状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址">
          <el-input
            v-model="editForm.address"
            auto-complete="off"
            type="textarea"
            autosize
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="editForm.remark"
            auto-complete="off"
            type="textarea"
            autosize
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="登录名" prop="loginName">
          <el-col :span="16">
            <el-input
              v-model="addForm.loginName"
              auto-complete="off"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-col :span="16">
            <el-input v-model="addForm.realName" auto-complete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="密码" prop="loginPWD">
          <el-col :span="16">
            <el-input
              v-model="addForm.loginPwd"
              show-password
              auto-complete="off"
            ></el-input>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="所属公司" prop="organizationId">
                    <el-select v-model="addForm.organizationId" placeholder="请选择所属公司">
                        <el-option v-for="item in currentUserOrganizations" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item> -->
        <el-form-item label="角色" prop="roleIds">
          <el-select
            multiple
            v-model="addForm.roleIds"
            placeholder="请选择角色"
          >
            <!-- <el-option  :key="0" :label="'未选择角色'" :value="0"></el-option> -->
            <el-option
              v-for="item in roles"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-col :span="16">
            <el-input v-model="addForm.email" auto-complete="off"></el-input>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="性别">
                    <el-radio-group v-model="addForm.sex">
                        <el-radio class="radio" :label="1">男</el-radio>
                        <el-radio class="radio" :label="0">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="年龄">
                    <el-input-number v-model="addForm.age" :min="0" :max="200"></el-input-number>
                </el-form-item>
                <el-form-item label="生日">
                    <el-date-picker type="date" placeholder="选择日期" v-model="addForm.birth"></el-date-picker>
                </el-form-item> -->
        <el-form-item label="状态" prop="enabled">
          <el-select v-model="addForm.status" placeholder="请选择状态">
            <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址">
          <el-input
            v-model="addForm.address"
            auto-complete="off"
            type="textarea"
            autosize
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="addForm.remark"
            auto-complete="off"
            type="textarea"
            autosize
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!-- 数据权限配置界面 -->
    <el-dialog
      title="数据权限分配"
      :visible.sync="assignFormVisible"
      v-model="assignFormVisible"
      :close-on-click-modal="false"
      width="70%"
    >
      <el-card>
        <div slot="header" class="clearfix">
          <div>
            <h4>当前用户：{{ currentRow ? currentRow.realName : "" }}</h4>
          </div>
          <div class="buttons">
            <el-button size="mini" @click="setAllChecked">全选</el-button>
            <el-button size="mini" @click="resetChecked">清空</el-button>
          </div>
        </div>
        <el-tabs tab-position="right" @tab-click="clickAssignTab">
          <el-tab-pane label="公司权限">
            <el-form :v-model="assignForm">
              <el-form-item label="" prop="organizationIds">
                <el-checkbox-group v-model="assignForm.ids">
                  <el-checkbox
                    v-for="org in organizations"
                    :key="org.id"
                    :label="org.id"
                    :disabled="
                      org.id ==
                      (currentRow != null ? currentRow.organizationId : 0)
                    "
                    :title="org.fullName"
                    style="width: 330px"
                  >
                    <el-tag v-if="!org.enabled" type="danger" size="mini"
                      >已禁用</el-tag
                    >
                    {{ cutString(org.fullName, 30) }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="仓库权限">
            <el-form :v-model="warehouseAssignForm">
              <el-form-item label="" prop="warehouseIds">
                <el-checkbox-group v-model="warehouseAssignForm.ids">
                  <el-checkbox
                    v-for="ware in warehouses"
                    :key="ware.warehouseId"
                    :label="ware.warehouseId"
                    :title="ware.warehouseName"
                    style="width: 330px"
                  >
                    <el-tag v-if="ware.status == 1" type="danger" size="mini"
                      >已禁用</el-tag
                    >
                    {{ cutString(ware.warehouseName, 30) }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </el-card>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="assignFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="assignSubmit"
          :loading="assignLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { cutString } from "../../../util/validate";
import {
  testapi,
  getUserListPage,
  getRoleListPage,
  getOrganizationListPage,
  removeUser,
  editUser,
  resetUser,
  addUser,
  addUserDataPermission,
  getWarehouseByOrg,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        keyword: "",
        enabled: "",
      },
      users: [],
      organizations: [],
      currentOrganizationId: 0,
      currentUserOrganizations: [],
      warehouses: [],
      roles: [],
      total: 0,
      buttonList: [],
      statusList: [
        { name: "正常", value: 1 },
        { name: "禁用", value: 0 },
      ],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        loginName: [
          { required: true, message: "请输入登录名", trigger: "blur" },
          { max: 30, message: "最多30个字符", trigger: "blur" },
        ],
        realName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { max: 30, message: "最多30个字符", trigger: "blur" },
        ],
        roleIds: [
          {
            type: "array",
            required: true,
            message: "请选择角色",
            trigger: "change",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      //编辑界面数据
      editForm: {
        id: 0,
        roleIds: 0,
        loginName: "",
        realName: "",
        email: "",
        sex: 1,
        age: 18,
        birth: "2021-01-01",
        address: "",
        remark: "",
        status: 1,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        loginName: [
          { required: true, message: "请输入登录名", trigger: "blur" },
          { max: 30, message: "最多30个字符", trigger: "blur" },
        ],
        realName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { max: 30, message: "最多30个字符", trigger: "blur" },
        ],
        loginPwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        // organizationId: [
        //     { required: true, message: '请选择所属公司', trigger: 'blur' }
        // ],
        roleIds: [
          {
            type: "array",
            required: true,
            message: "请选择角色",
            trigger: "change",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      //新增界面数据
      addForm: {
        loginName: "",
        realName: "",
        loginPwd: "",
        organizationId: 0,
        email: "",
        roleIds: 0,
        sex: 1,
        age: 18,
        birth: "2021-01-01",
        address: "",
        remark: "",
        status: 1,
      },
      assignFormVisible: false,
      assignLoading: false,
      assignForm: {
        assignType: 0,
        ids: [],
        userId: 0,
      },
      warehouseAssignForm: {
        assignType: 1,
        ids: [],
        userId: 0,
      },
      tabIndex: "0",
    };
  },
  methods: {
    clickAssignTab(tab, event) {
      this.tabIndex = tab.index;
    },
    cutString: function (str, len) {
      return cutString(str, len);
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    //性别显示转换
    formatSex: function (row, column) {
      return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
    },
    formatBirth: function (row, column) {
      return !row.birth || row.birth == ""
        ? ""
        : util.formatDate.format(new Date(row.birth), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getUsers();
    },
    //获取用户列表
    getUsers() {
      let para = {
        page: this.page,
        key: this.filters.keyword,
        enabled: this.filters.enabled.toString(),
      };
      this.listLoading = true;
      //NProgress.start();
      getUserListPage(para).then((res) => {
        const { total, tableData } = res.data.response;

        this.total = res.data.response.total;
        this.users = res.data.response.pageData;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    handleEnable() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要启用的一行数据！",
          type: "error",
        });

        return;
      }
      if (row.status === 1) {
        this.$message({
          message: "当前数据为启用状态，无需启用！",
          type: "success",
        });

        return;
      }
      row.status = 1;
      let para = Object.assign({}, row);
      editUser(para).then((res) => {
        if (util.isEmt.format(res)) {
          return;
        }

        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getUsers();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    handleStop() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要禁用的一行数据！",
          type: "error",
        });

        return;
      }
      if (row.status === 0) {
        this.$message({
          message: "当前数据为禁用状态，无需禁用！",
          type: "success",
        });

        return;
      }
      row.status = 0;
      let para = Object.assign({}, row);
      editUser(para).then((res) => {
        if (util.isEmt.format(res)) {
          return;
        }

        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getUsers();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    handleReset() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要重置密码的一行数据！",
          type: "error",
        });

        return;
      }
      let para = Object.assign({}, row);
      resetUser(para).then((res) => {
        if (res.data.success) {
          this.showNotification(res.data.msg);
          // this.$message({
          //     message: res.data.msg,
          //     type: "success"
          // });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.id };
          removeUser(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getUsers();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);

      getRoleListPage().then((res) => {
        this.roles = res.data.response.pageData;
      });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      let user = JSON.parse(window.localStorage.user);
      this.addForm = {
        loginName: "",
        loginPwd: "",
        realName: "",
        organizationId: user.organizationId,
        roleIds: 0,
        sex: -1,
        age: 0,
        birth: "",
        address: "",
        remark: "",
      };
      getRoleListPage({ enabled: 1 }).then((res) => {
        this.roles = res.data.response.pageData;
      });
    },
    handleAssign() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要操作的一行数据！",
          type: "error",
        });

        return;
      }
      this.assignFormVisible = true;
      this.assignForm.userId = row.id;
      this.warehouseAssignForm.userId = row.id;
      this.assignForm.ids = row.organizationIds;
      this.warehouseAssignForm.ids = row.warehouseIds;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");

            editUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getUsers();
              } else {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.birth =
              !para.birth || para.birth == ""
                ? util.formatDate.format(new Date(), "yyyy-MM-dd")
                : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");
            addUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getUsers();
              } else {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    assignSubmit: function () {
      this.assignLoading = true;
      // let para = {};
      // if (this.tabIndex==='0'){
      //     para = Object.assign({}, this.assignForm);
      // }else{
      //     para = Object.assign({}, this.warehouseAssignForm);
      // }

      let para = [];
      para.push(Object.assign({}, this.assignForm));
      para.push(Object.assign({}, this.warehouseAssignForm));
      addUserDataPermission(para).then((res) => {
        if (util.isEmt.format(res)) {
          this.assignLoading = false;
          return;
        }
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.assignLoading = false;
          this.assignForm.ids = [];
          this.warehouseAssignForm.ids = [];
          this.assignForm.userId = 0;
          this.assignFormVisible = false;
          this.getUsers();
        } else {
          this.assignLoading = false;
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    setAllChecked: function () {
      var _this = this;
      let ids = [];
      if (_this.tabIndex === "0") {
        for (var i = 0; i < _this.organizations.length; i++) {
          ids.push(_this.organizations[i].id);
        }
        _this.assignForm.ids = ids;
      } else {
        for (var i = 0; i < _this.warehouses.length; i++) {
          ids.push(_this.warehouses[i].warehouseId);
        }
        _this.warehouseAssignForm.ids = ids;
      }
    },
    resetChecked: function () {
      var _this = this;
      let ids = [];
      if (_this.tabIndex === "0") {
        ids.push(this.currentOrganizationId);
        _this.assignForm.ids = ids;
      } else {
        _this.warehouseAssignForm.ids = ids;
      }
    },
    showNotification: function (msg) {
       const h = this.$createElement;
          
          const copyButton = h('button', {
            class: 'notification-btn copy-btn',
            on: {
              click: () => {
                this.copyToClipboard(msg);
                this.$message({
                  message: '内容已复制到剪贴板',
                  type: 'success',
                  duration: 1500
                });
              }
            }
          }, '复制');
          
          const closeButton = h('button', {
            class: 'notification-btn close-btn',
            on: {
              click: () => {
                notification.close();
              }
            }
          }, '关闭');
          
          const buttonsContainer = h('div', {
            class: 'notification-buttons'
          }, [copyButton, closeButton]);
          
          const messageContent = h('div', {
            class: 'notification-content'
          }, msg);
          
          const customContent = h('div', {
            class: 'custom-notification'
          }, [messageContent, buttonsContainer]);
          
          const notification = this.$notify({
            title: '操作成功',
            message: customContent,
            type: 'info',
            duration: 0,
            customClass: 'wide-notification'
          });
    },
    copyToClipboard: function (text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("复制失败:", err);
      }
      document.body.removeChild(textArea);
    },
  },
  mounted() {
    getOrganizationListPage({ pageSize: 100, key: "", includeSelf: true }).then(
      (res) => {
        this.organizations = res.data.response.pageData;
      }
    );

    let user = JSON.parse(window.localStorage.user);
    this.currentOrganizationId = user.organizationId;
    this.currentUserOrganizations = user.organizationList;
    if (user.organizationType === 10) {
      this.warehouses = user.warehouseList;
    } else {
      getWarehouseByOrg({ orgId: user.organizationId }).then((res) => {
        this.warehouses = res.data.response.wareHouse;
      });
    }
    this.getUsers();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-btn {
      padding: 12px 24px;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.3s;
      font-weight: 500;
      background-color: #409EFF;
      color: white;
    }
    
    .custom-btn:hover {
      background-color: #66b1ff;
    }
    
    /* 自定义通知宽度样式 */
    .wide-notification {
      width: 500px !important;
    }
    
    .custom-notification {
      width: 100%;
    }
    
    .notification-content {
      margin-bottom: 15px;
      line-height: 1.5;
    }
    
    .notification-buttons {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      margin-top: 15px;
    }
    
    .notification-btn {
      padding: 7px 15px;
      border: 1px solid;
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      transition: all 0.3s;
      background: white;
    }
    
    .copy-btn {
      border-color: #409EFF;
      color: #409EFF;
    }
    
    .copy-btn:hover {
      background: #409EFF;
      color: white;
    }
    
    .close-btn {
      border-color: #909399;
      color: #909399;
    }
    
    .close-btn:hover {
      background: #909399;
      color: white;
    }
    
    .instructions {
      background: white;
      border-radius: 10px;
      padding: 25px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
      margin-top: 30px;
    }
    
    .instructions h3 {
      color: #409EFF;
      margin-bottom: 15px;
    }
    
    .code-block {
      background-color: #f5f7fa;
      padding: 15px;
      border-radius: 4px;
      margin: 15px 0;
      font-family: 'Courier New', monospace;
      border-left: 4px solid #409EFF;
      overflow-x: auto;
    }
</style>
